// Interfaces
import { ISearchItem, ISearchCriteriaArgs } from "./interfaces";

const isSearchMatch = (item: ISearchItem, search = "", listNodes: string[] = []) => {
	const lowerSearch = search.toString().toLowerCase();
	return listNodes.some((key) => item?.[key as keyof object]?.toString().toLowerCase().includes(lowerSearch));
};

const groupsBySearchCriteria = (data: ISearchItem[] = [], args: ISearchCriteriaArgs | undefined = undefined) => {
	const { root, nodes = [], search = "" } = args ?? {};
	if (!search && !root) {
		return [
			{
				title: "",
				list: data,
				filteredOut: false,
			},
		];
	}

	const mapFilteredOut = (item: ISearchItem) => ({ ...item, filteredOut: !isSearchMatch(item, search, nodes) });

	if (!root) {
		return [
			{
				title: "",
				list: data?.map(mapFilteredOut),
				filteredOut: false,
			},
		];
	}

	let groups = data?.map((item) => item?.[root]);
	groups = [...new Set(groups)];

	return groups.map((group) => {
		let list = data?.filter((item) => item?.[root] === group);
		if (search) {
			list = list.map(mapFilteredOut);
		}
		return {
			title: group,
			filteredOut: list.every((item) => item.filteredOut),
			list,
		};
	});
};

export { groupsBySearchCriteria };
